<template>
  <div class="lxn-w100 lxn-viewWithMaxWidth lxn-margin-auto">
    <div class="PairNodeNodeNotResponding-topCurve-wrapper lxn-w100">
      <CustomCurve>
          <TopNav @leftTextClick="goBack" :leftText="$store.getters.language.texts.PairNodeNodeNotResponding_Cancel" leftIcon="x" centerText="" rightText=""></TopNav>
      </CustomCurve>
    </div>
    <div class="PairNodeNodeNotResponding-main-wrapper lxn-pos-rel lxn-margin-auto lxn-border-round">
      <WrapperSvgTitleText>
        <template v-slot:svg>
          <svg viewBox="0 0 113.39 113.39">
            <g transform="translate(175.085 -251.936)">
              <path class="PairNodeNodeNotResponding-st0" d="M-154.39,251.94h72c11.43,0,20.69,9.26,20.69,20.69v72c0,11.43-9.26,20.69-20.69,20.69h-72c-11.43,0-20.69-9.26-20.69-20.69v-72C-175.09,261.2-165.82,251.94-154.39,251.94z"/>
              <path class="PairNodeNodeNotResponding-st1" d="M-77.48,353.99c0,0-15.68,2.86-40.91,2.86s-40.91-2.86-40.91-2.86c-2.46,0-4.45-1.99-4.45-4.45c0,0-2.86-15.68-2.86-40.91s2.86-40.91,2.86-40.91c0-2.46,1.99-4.45,4.45-4.45h0c0,0,15.68-2.86,40.91-2.86s40.91,2.86,40.91,2.86c2.46,0,4.45,1.99,4.45,4.45l0,0c0,0,2.86,15.68,2.86,40.91s-2.86,40.91-2.86,40.91C-73.03,352-75.02,353.99-77.48,353.99C-77.48,353.99-77.48,353.99-77.48,353.99z"/>
            </g>
            <path class="PairNodeNodeNotResponding-st2" d="M70.78,75.27c-6.01,10.51-21.16,10.51-27.18,0l-11.22-19.6c-5.98-10.44,1.56-23.44,13.59-23.44h22.44c12.03,0,19.56,13,13.59,23.44L70.78,75.27z"/>
            <rect x="53.97" y="65.85" class="PairNodeNodeNotResponding-st3" width="6.45" height="6.45"/>
            <rect x="53.97" y="40.06" class="PairNodeNodeNotResponding-st3" width="6.45" height="19.34"/>
          </svg>
        </template>
        <template v-slot:title>
          {{$store.getters.language.texts.PairNodeNodeNotResponding_title}}
        </template>
        <template v-slot:text>
          {{$store.getters.language.texts.PairNodeNodeNotResponding_text}}
        </template>
      </WrapperSvgTitleText>
    </div>
    <div class="PairNodeNodeNotResponding-button lxn-margin-auto lxn-w100">
      <CustomButton @click="next" bgColor="#1EA5DE" iconRight="arrowRight" iconRightColor="#1EA5DE" iconRightBgColor="#D5E6F0" textColor="#FFFFFF" :iconRightPadding="8" :useLanguageDirection="true">
        {{$store.getters.language.texts.PairNodeNodeNotResponding_button}}
      </CustomButton>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import CustomCurve from '@/components/CustomCurve.vue'
import TopNav from '@/components/TopNav.vue'
import WrapperSvgTitleText from '@/components/addNewDevice/WrapperSvgTitleText.vue'
import CustomButton from '@/components/CustomButton.vue'


export default {
  name: 'PairNodeNodeNotResponding',
  components: {
    CustomCurve,
    TopNav,
    WrapperSvgTitleText,
    CustomButton
  },
  methods: {
    goBack: function () {
      this.$router.push('/home/devices');
    },
    next: function () {
      this.$router.push("/pairNode/" + this.$route.params.nodeUUID);
    }
  }
}
</script>

<style>
  .PairNodeNodeNotResponding-topCurve-wrapper {
    height: 200px;
  }
  .PairNodeNodeNotResponding-main-wrapper {
    width: calc(100% - 36px);
    margin-top: -150px;
    z-index: 1;
    background-color: #ffffff;
  }
  .PairNodeNodeNotResponding-button {
    width: calc(100% - 36px);
    margin-bottom: 14px;
  }
	.PairNodeNodeNotResponding-st0 {
    fill: #ECECEC;
  }
	.PairNodeNodeNotResponding-st1 {
    fill: #53636C;
  }
	.PairNodeNodeNotResponding-st2 {
    fill: #FFFFFF;
  }
	.PairNodeNodeNotResponding-st3 {
    fill: #F36C4F;
  }
</style>
